/** Full-viewport studios map route, kept outside the discovery layout route. */
import { createFileRoute } from '@tanstack/react-router';
import styles from '@/components/v2/discovery/discovery-page.module.less';

// Component lives in the .lazy sibling so the map UI bundle (and the base-ui
// drawer it drags in) stays out of the entry chunk; this route used to be one
// of the eager-boot heaviest non-tab destinations. The pending shell mirrors
// the page's own fullscreen frame — a bare canvas reads as "map tiles loading"
// rather than the app vanishing; a list template would be the wrong shape for
// a chrome-less map.
export const Route = createFileRoute('/_authenticated/discovery_/studios/map')({
  pendingComponent: () => (
    <section className={styles.mapFullscreen} aria-busy="true" aria-label="Studios map loading" />
  ),
});
